import { alpha } from '@mui/material';

export const styles = {
  container: (theme, isDropdown) => ({
    mb: isDropdown ? 0 : 2,
    px: isDropdown ? 2 : 2,
    py: isDropdown ? 1.5 : 1.5,
    backgroundColor: isDropdown ? 'transparent' : theme.palette.background.paper,
    borderRadius: isDropdown ? 0 : { xs: 2, sm: 3 },
    border: isDropdown ? 'none' : `1px solid ${alpha(theme.palette.text.primary, 0.2)}`,
    borderBottom: isDropdown ? 'none' : `1px solid ${alpha(theme.palette.text.primary, 0.2)}`,
    transition: 'all 0.3s ease',
    boxShadow: isDropdown ? 'none' : `0 8px 32px ${alpha(theme.palette.common.black, 0.08)}`,
    position: 'relative',
    overflow: 'hidden',
  }),
  modeToggleSection: (isDropdown) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: isDropdown ? 1 : 1,
  }),
  modeToggleLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
  },
  modeAvatar: (theme, isDark, isDropdown) => ({
    width: 28,
    height: 28,
    bgcolor: isDropdown 
      ? 'rgba(255, 255, 255, 0.1)'
      : (isDark ? alpha(theme.palette.primary.main, 0.1) : alpha(theme.palette.action.hover, 0.1)),
    color: isDropdown
      ? '#ffffff'
      : (isDark ? theme.palette.primary.main : theme.palette.text.secondary),
    transition: 'all 0.3s ease',
  }),
  modeTitle: (isDropdown, theme) => ({
    fontWeight: 700,
    fontSize: { xs: '0.95rem', sm: '1.05rem' },
    color: isDropdown ? '#ffffff' : 'text.primary',
    whiteSpace: 'nowrap',
    minWidth: '85px',
  }),
  modeSubtitle: (isDropdown, theme) => ({
    fontSize: { xs: '0.8rem', sm: '0.85rem' },
    color: isDropdown ? 'rgba(255, 255, 255, 0.7)' : 'text.secondary',
  }),
  switchStyles: (theme) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: theme.palette.primary.main,
      opacity: 0.8,
    }
  }),
  variantSection: (theme, isDropdown) => ({
    mt: isDropdown ? 1.5 : 1.5,
    borderTop: isDropdown ? '1px solid rgba(255, 255, 255, 0.08)' : `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
    pt: isDropdown ? 1.5 : 1.5,
  }),
  variantTitle: (isDropdown, theme) => ({
    mb: isDropdown ? 1 : 1,
    fontWeight: 500,
    fontSize: '0.8rem',
    color: isDropdown ? 'rgba(255, 255, 255, 0.7)' : 'text.secondary',
  }),
  variantContainer: (isDropdown) => ({
    display: 'flex',
    gap: isDropdown ? 1 : 1.5,
    flexWrap: 'wrap',
  }),
  variantCircle: (theme, v, isSelected, isDropdown) => {
    const size = isDropdown ? 28 : 28;
    return {
      width: size,
      height: size,
      borderRadius: '50%',
      cursor: 'pointer',
      position: 'relative',
      backgroundColor: v.previewBg,
      border: isSelected ? `2px solid ${theme.palette.primary.main}` : `1px solid ${theme.palette.divider}`,
      boxShadow: isSelected ? `0 0 0 3px ${alpha(theme.palette.primary.main, 0.2)}` : 'none',
      transition: 'all 0.2s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': {
        transform: 'scale(1.1)',
      }
    };
  },
  innerCircle: (v, isDropdown) => ({
    width: isDropdown ? 10 : 16,
    height: isDropdown ? 10 : 16,
    borderRadius: '50%',
    backgroundColor: v.previewPrimary,
  }),
  variantLabel: (isDropdown, isSelected, theme) => ({
    fontSize: '0.65rem',
    color: isDropdown 
      ? (isSelected ? '#ffffff' : 'rgba(255, 255, 255, 0.5)') 
      : (isSelected ? theme.palette.text.primary : theme.palette.text.secondary),
    fontWeight: isSelected ? 600 : 400,
    textAlign: 'center',
    maxWidth: isDropdown ? 40 : 48,
    lineHeight: 1.1,
  }),
};
